import { render, staticRenderFns } from "./anzhidian.vue?vue&type=template&id=22bc7fe4&scoped=true"
import script from "./anzhidian.vue?vue&type=script&lang=js"
export * from "./anzhidian.vue?vue&type=script&lang=js"
import style0 from "./anzhidian.vue?vue&type=style&index=0&id=22bc7fe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bc7fe4",
  null
  
)

export default component.exports